export const getCSRAdminPortalPae = (userView, messageType) => {
  return messageType?.toLowerCase() !== "company wide" &&
    messageType?.toLowerCase() !== "companywide"
    ? userView
    : "Dashboard & Alerts";
};
